import Base from "@/api/Base";

export default class Init extends Base
{
	setFunctions (v)
	{
		this.data.functions = v;
		return this;
	}

	setCareerLevels (v)
	{
		this.data.careerLevels = v;
		return this;
	}

	setIndustrialSectors (v)
	{
		this.data.industrialSectors = v;
		return this;
	}

	setOrganisationalArea (v)
	{
		this.data.organisationalArea = v;
		return this;
	}

	setEmploymentModes (v)
	{
		this.data.employmentModes = v;
		return this;
	}

	setWorkingTime (v)
	{
		this.data.workingTime = v;
		return this;
	}

	setGeo (v)
	{
		this.data.geo = v;
		return this;
	}

	setHomeOffice (v)
	{
		this.data.homeOffice = v;
		return this;
	}

	setPersonalData (v)
	{
		this.data.personalData = v;
		return this;
	}

	setSecurity (v)
	{
		this.data.security = v;
		return this;
	}

	getMethod ()
	{
		return 'POST';
	}

	getUrl ()
	{
		return '/kandidat';
	}
}
